{
  "projectName": "Washi",
  "words": {
    "selected": "sélectionné",
    "cancel": "annuler",
    "confirm": "valider"
  },
  "resume": {
    "sections": {
      "fr": {
        "candidateInfo": "Infos générales",
        "conviction": "Convictions & Veille",
        "skills": "Compétences techniques",
        "common-context": "Contexte",
        "common-missions": "Missions",
        "common-technical-environment": "Environnement technique",
        "formations": "Formations",
        "projects": "Projets perso",
        "experiences": "Expériences",
        "experiences-context": "Expériences",
        "experiences-projects": "Projets",
        "contact": "Contact"
      },
      "en": {
        "candidateInfo": "General info",
        "conviction": "Convictions & Tech watch",
        "skills": "Technical skills",
        "common-context": "Context",
        "common-missions": "Missions",
        "common-technical-environment": "Technical environment",
        "formations": "Trainings",
        "projects": "Personal projects",
        "experiences": "Experiences",
        "experiences-context": "Experiences",
        "experiences-projects": "Projects",
        "contact": "Contact"
      }
    }
  },
  "workspaces": {
    "_1": "organisation",
    "_2": "mon espace personnel",
    "_3": "partagé avec moi"
  },
  "topBar": {
    "offlineWarning": "Attention vous etes hors ligne",
    "updatesSaved": "Toutes les modifications ont été enregistrées",
    "errorSaving": "Une erreur est survenue durant la sauvegarde du document.",
    "saving": "Sauvegarde en cours ...",
    "designMode": "design",
    "editorMode": "éditeur",
    "sharing": "partager",
    "export": "exporter",
    "profil": "profil",
    "signup": "Créer un compte",
    "duplicate": "dupliquer",
    "translate": "traduire"
  },
  "home": {
    "topbar": {
      "about": "about",
      "pricing": "pricing",
      "login": "Se connecter",
      "signUp": "Créer un compte"
    },
    "footer": {
      "login": "Se connecter",
      "signUp": "Créer un compte",
      "contact": "Contact"
    },
    "about": {
      "title": "L’éditeur et gestionnaire de dossiers de compétences le plus performant du marché",
      "text_html": "<p>Que vous soyez <b>entrepreneur, indépendant, responsable commercial/RH</b> en <b>agence</b> ou <b>société de conseil</b>, gagnez du temps avec Washi et créez vos <b>dossiers de compétences</b> en quelques minutes.</p><p>Pensez au fond, nous gérons la forme.</p>",
      "startButton": "Créer un dossier"
    },
    "mission": {
      "title": "Notre mission",
      "text_html": "<p>Nous prêtons une attention particulière au temps requis afin de rédiger et <b>mettre en page</b> des documents <b>créateurs de valeur.</b></p><br><p>À travers Washi, notre objectif est de proposer un outil spécifiquement conçu <b>pour les professionnels</b> afin que ces derniers puissent se focaliser exclusivement sur leurs objectifs.</p>"
    },
    "pricing": {
      "title_html": "<p>Exploitez tout le potentiel de Washi.</p><p>Des tarifs adaptés à vos besoins.</p>",
      "cards": {
        "basic": {
          "title_html": "<b>BASIC</b> (gratuit)",
          "text_html": "<p><b>5</b> Dossiers</p><p><i class=\"light\">Possibilité de partager</i></p><p><b>2</b> Templates</p><p><b>3</b> Palettes de couleurs</p>",
          "startButton": "Créer un compte"
        },
        "pro": {
          "title_html": "<b>PRO</b> (5€/mois)",
          "text_html": "<p>Dossiers <b>illimités</b></p><p><i class=\"light\">Possibilité de partager</i></p><p>Templates <b>au choix</b> </p><p>Palettes de couleurs <b>illimités</b> </p>",
          "startButton": "débuter la souscription"
        },
        "enterprise": {
          "title_html": "<b>ENTREPRISE</b> (sur devis)",
          "text_html": "<p>Outil sur-mesure</p>",
          "startButton": "nous contacter"
        }
      }
    },
    "popup": {
      "createResume": {
        "title": "créer un dossier",
        "message": "Vous avez déjà un dossier en cours d'édition. Souhaitez-vous continuer à travailler sur ce dossier ou en créer un nouveau et écraser le précédent ?",
        "resumeEditing": "CONTINUER L'EDITION",
        "createNew": "CREER UN NOUVEAU DOSSIER",
        "resumeTypeChoice": "Veuillez choisir de quelle manière vous souhaitez créer votre dossier.",
        "resumeFromScratch": "Créer un CV de zéro",
        "importResume": "Importer un CV"
      }
    }
  },
  "login": {
    "title": "Welcome Back !",
    "noAccount": "Vous n’avez pas de compte ?",
    "signup": "Créer un compte",
    "wrongCredentials": "L'adresse email ou le mot de passe que vous avez entré n'est pas valide.",
    "tooManyRequests": "Vous avez fait trop de tentatives, veuillez essayer plus tard",
    "fields": {
      "email": "E-mail",
      "password": "Mot de passe",
      "forgotPassword": "Mot de passe oublié ?",
      "passwordConfirm": "Confirmation de mot de passe"
    },
    "buttons": {
      "google": "Connexion avec Google",
      "login": "Se connecter",
      "signup": "Créer un compte",
      "resetPassword": "Changer mon mot de passe"
    }
  },
  "register": {
    "title": "Welcome !",
    "createAccount": "Créez un compte",
    "andStartToUse": "et commencez à utiliser",
    "alreadyHaveAccount": "Vous êtes déjà inscrit ?",
    "login": "Se connecter",
    "fields": {
      "firstname": "Prénom",
      "lastname": "Nom"
    },
    "errors": {
      "default": "Une erreur est survenue",
      "emailExist": "Cette E-mail est déja enregistrée",
      "emailIsInvalid": "Entrez une adresse e-mail valide.",
      "confirmError": "Les mots de passe ne correspondent pas"
    },
    "password": {
      "shouldContain": "Votre mot de passe doit contenir :",
      "minimumLetters": "Au moins 8 caractères",
      "capital": "Une majuscule et une minuscule",
      "numberOrSymbol": "Un chiffre ou un symbole"
    }
  },
  "editor": {
    "newPage": "Démarrer une nouvelle page",
    "topbar": {
      "goTo": "aller à"
    },
    "messages": {
      "saved": "Toutes les modifications ont été enregistrées",
      "saving": "En cours d'enregistrement",
      "readOnly": "Mode: lecture seule"
    },
    "buttons": {
      "editor": "Editeur",
      "design": "Design",
      "preview": "Preview",
      "export": "Export",
      "copyLink": "Copier l'URL",
      "delete": "Supprimer"
    },
    "candidateInfo": {
      "firstname": "Prénom du candidat",
      "lastname": "Nom du candidat",
      "hideLastname": "Cacher le nom",
      "job": "poste",
      "link": "Portfolio",
      "email": "e-mail",
      "phone": "téléphone",
      "location": "lieu",
      "delete": "supprimer la compétence",
      "add": "ajouter une compétence"
    },
    "convictions": {
      "values": "détails",
      "delete": "supprimer la compétence",
      "add": "ajouter une compétence",
      "hide": "cacher la section"
    },
    "skills": {
      "name": "catégorie",
      "values": "détails",
      "delete": "supprimer la compétence",
      "add": "ajouter une compétence"
    },
    "formations": {
      "date": "date",
      "name": "nom de la formation",
      "values": "détails",
      "delete": "supprimer la formation",
      "add": "ajouter une formation"
    },
    "projects": {
      "date": "date",
      "name": "nom du projet",
      "values": "détails",
      "technos": "Environnement technique",
      "delete": "supprimer le projet",
      "add": "ajouter un projet"
    },
    "experiences": {
      "date": "date",
      "name": "nom du projet",
      "job": "poste",
      "client": "client",
      "missions": "missions",
      "values": "contexte",
      "technos": "environnement technique",
      "delete": "supprimer l'experience",
      "add": "ajouter une experience"
    },
    "contact": {
      "title": "contact",
      "hide": "cacher la section",
      "companyName": "nom de la société",
      "address": "adresse",
      "firstname": "prénom",
      "lastname": "nom",
      "phone": "téléphone",
      "email": "email",
      "replceWithPersonal": "remplacer avec mes coordonnées"
    },
    "design": {
      "colorPalettes": "Palettes de couleurs",
      "templates": "Templates",
      "select": "Sélectionner"
    },
    "panel": {
      "addCategory": {
        "formations": "Ajouter une formation",
        "projects": "Ajouter un projet",
        "experiences": "Ajouter une expérience"
      }
    }
  },
  "dashboard": {
    "invitationStatus": {
      "_0": "Membre depuis le {since}",
      "_1": "Invitation rejetée",
      "_2": "En attente depuis le {since}",
      "_3": "Membre depuis le {since}",
      "_4": "Invitation expirée"
    },
    "notification": {
      "cantShare": "Le dossier de compétences n'a pas pu être partagé avec <b>{email}</b>",
      "added": "<b>{email}</b> a bien été ajouté !",
      "alreadyHaveAccess": "<b>{email}</b> a déjà accès à ce dossier de compétences depuis l'organisation <b>{organization}</b>"
    },
    "workspaceGroup": {
      "personal": "Mon espace personnel",
      "shared": "Partagés avec moi",
      "edit": "Éditer & Inviter"
    },
    "createButtons": {
      "organization": "Créer une organisation",
      "resume": "Créer un nouveau dossier"
    },
    "searchResult": {
      "inputPlaceholder": "Rechercher un dossier, un nom, un poste...",
      "title": "Résultats de recherche",
      "singular": " résultat",
      "plural": " résultats",
      "noResult": "Aucun résultat ne correspond à votre recherche"
    },
    "emptyGroup": {
      "sentence": "Votre espace est vide",
      "link": "Cliquez ici pour créer votre dossier de compétences",
      "linkMobile": "Rendez-vous sur ordinateur pour<br/>créer votre premier dossier de compétence"
    },
    "filters": {
      "name": "Nom ",
      "labels": "Labels",
      "jobTitle": "Poste",
      "repertory": "Répertoire",
      "date": "Modifié "
    },
    "editAction": {
      "label": "Labelliser",
      "move": "Déplacer",
      "duplicate": "Dupliquer",
      "share": "Partager",
      "delete": "Supprimer",
      "unfollow": "Ne plus suivre"
    },
    "sharedPopin": {
      "sharedBy": "Partagé par",
      "sharedWith": "Partagé avec",
      "person": {
        "singular": " personne",
        "plural": " personnes"
      },
      "member": {
        "singular": " membre",
        "plural": " membres"
      }
    }
  },
  "popUp": {
    "resumeParsing": {
      "filesAreImporting": "Les fichiers sont en cours d’importation.",
      "filesAreDoneImporting": "Les fichiers ont été importés avec succès !",
      "datasAreLoading": "Données en cours de récupération.",
      "dataFetchingError": "Les fichiers n’ont pas été téléchargés...",
      "error": "Erreur"
    },
    "translation": {
      "title": "Traduire le dossier",
      "generalInfo": "Informations générales",
      "originLanguage": "Langue actuelle du dossier",
      "targetLanguage": "Traduction souhaitée",
      "details": "Le dossier sera dupliqué avec un dossier comprenant la traduction souhaitée",
      "cancel": "Annuler",
      "translate": "Traduire",
      "langChoice": "Veuillez choisir une langue"
    },
    "createResume": {
      "title": "Créer un nouveau dossier",
      "template": "Choix du template",
      "infos": "Informations générales",
      "firstname": "Prénom du candidat",
      "lastname": "Nom du candidat",
      "jobTitle": "Poste",
      "labels": "Labels",
      "labelsHelp": "Chaque espace de travail dispose de ses labels dédiés",
      "mandatoryField": "* champs obligatoires",
      "personalGroup": "Mon espace perso",
      "previous": "précédent",
      "createButton": "CRÉER LE DOSSIER",
      "jobPlaceHolder": "Développeur Front",
      "resumeTypeChoice": "Veuillez choisir de quelle manière vous souhaitez créer votre dossier.",
      "resumeFromScratch": "Créer un CV de zéro",
      "importResume": "Importer un CV",
      "importDescription": "Veuillez importer jusqu’à 10 fichiers PDF",
      "previousStep": "Étape précédente",
      "addFiles": "Ajouter des fichiers",
      "continue": "Continuer",
      "fileTooLarge": "Vos fichiers ne peuvent pas dépasser 5Mo.",
      "tooManyFiles": "Vous pouvez ajouter jusqu'à 10 fichiers par import.",
      "importYourFiles": "Importer vos fichiers",
      "dropFiles": "Déposer un maximum de 10 fichiers ici",
      "acceptedFormat": "Format accepté : PDF (jusqu'à 5 Mo par fichier)",
      "spaceChoice": "Choix de mon espace",
      "importedFiles": "1 fichier importé | {count} fichiers importés",
      "validate": "Valider"
    },
    "duplicateResume": {
      "title": "DUPLIQUER LE DOSSIER",
      "template": "Choix du template",
      "infos": "Informations générales",
      "name": "Nom du candidat",
      "firstName": "Prénom du candidat",
      "jobTitle": "Poste",
      "labels": "Labels",
      "labelsHelp": "Chaque espace de travail dispose de ses labels dédiés",
      "pictureUrl": "Url photo de profil",
      "mandatoryField": "* champs obligatoires",
      "personalGroup": "Mon espace perso",
      "cancelButton": "ANNULER",
      "validateButton": "VALIDER",
      "duplicateChoiceText": "Veuillez choisir de quelle manière vous souhaitez dupliquer ce dossier.",
      "duplicateSameProfile": "Dupliquer pour le même profil",
      "duplicateSameProfileText": "Ce dossier sera lié aux autres dossiers existants du consultant",
      "duplicateOtherProfile": "Dupliquer pour un nouveau profil",
      "duplicateOtherProfileText": "Ce dossier sert de modèle pour un nouveau profil candidat"
    },
    "updateResumeLabels": {
      "title": "LABELLISER LE DOSSIER",
      "labels": "Labels",
      "cancelButton": "Annuler",
      "saveButton": "Enregistrer"
    },
    "shareResume": {
      "title": {
        "main": "PARTAGER LE DOSSIER ",
        "with": " AVEC"
      },
      "sendInvitation": "Envoyer une invitation",
      "sharedWith": "Partagé avec",
      "lastVisit": "Dernière visite le",
      "invitationSend": "Invitation envoyée",
      "leaveOrganization": "Quitter l'organisation",
      "kick": "Révoquer l’accès",
      "person": {
        "singular": "personne",
        "plural": "personnes"
      },
      "cancelButton": "ANNULER",
      "validateButton": "PARTAGER"
    },
    "moveResume": {
      "title": "DÉPLACER LE DOSSIER {resume}",
      "content": "Le dossier {resume} sera déplacé dans l’espace de votre organisation. Tous les membres de votre organisation y auront alors accès.",
      "button": "DÉPLACER"
    },
    "removeResume": {
      "title": "SUPPRIMER LE DOSSIER {resume}",
      "content": "Cette action ne peut être annulée et vous perdrez définitivement les données.",
      "button": "SUPPRIMER"
    },
    "unsharedResume": {
      "title": "NE PLUS SUIVRE LE DOSSIER {resume}",
      "content": "Vous perdrez l'accès au dossier {resume}.",
      "button": "NE PLUS SUIVRE"
    }
  },
  "organization": {
    "goBack": "RETOUR",
    "cancelButton": "ANNULER",
    "addLogo": "Ajouter un logo",
    "logoFormat": ".jpg,  .png et .gif acceptés",
    "maxSize": "{max} Mo maximum",
    "name": "Nom de l'organisation",
    "userEmail": "E-mail de l'utilisateur",
    "maxCharacters": "Veuillez entrer un nom d'organisation de moins de {max} caractères.",
    "errorMessage": "Veuillez entrer un nom d'organisation.",
    "errorMessageEmail": "Veuillez entrer l'email de l'utilisateur.",
    "createOrganization": {
      "title": "Créer une organisation",
      "createButton": "CRÉER"
    },
    "editOrganization": {
      "notification": {
        "hasBeenAdded": "<b>{email}</b> a bien été ajouté à <b>{organization}</b>",
        "alreadyJoin": "<b>{email}</b> a déjà rejoint <b>{organization}</b>",
        "alreadyInOrganization": "<b>{email}</b> n'a pas pu être ajouté à <b>{organization}</b> parce qu'il est déjà dans une organisation."
      },
      "title": "Modifier votre organisation",
      "address": "Adresse",
      "deleteOrganization": "Supprimer l’organisation",
      "person": {
        "singular": "personne",
        "plural": "personnes"
      },
      "leaveOrganization": "Quitter l’organisation",
      "revokeAccess": "Révoquer l’accès",
      "inviteCollaborators": "Inviter un collaborateur",
      "confirmButton": "TERMINER"
    }
  },
  "profil": {
    "goBack": "RETOUR",
    "title": "Mon profil",
    "personalInfo": "Informations personnelles",
    "firstname": "Prénom",
    "lastname": "Nom",
    "phone": "Téléphone",
    "mail": "E-mail",
    "logout": "Me déconnecter",
    "myOrganization": "Mon organisation",
    "memberSince": "Membre depuis le {since}",
    "modify": "MODIFIER",
    "leaveOrganization": "Quitter l’organisation",
    "cancelButton": "ANNULER",
    "confirmButton": "TERMINER"
  },
  "resumeLabelsSelect": {
    "search": "Rechercher",
    "searchIn": "Rechercher dans",
    "personalGroup": "Mon espace perso",
    "typeToSearch": "Tapez pour rechercher...",
    "createLabel": "Créer le label"
  }
}
